module.exports = __webpack_public_path__ + "img/adhesivos_y_selladores.03724508.jpg";